import React from 'react';

export default class PasswordFieldWithValidation extends React.Component {
  constructor(props) {
    super(props);

    this.initialState = {
      errorMessages: [],
      valid: this.props.valid,
      inputClass: 'initialized',
      errors: '',
      value: '',
    };
    this.state = this.initialState;

    this.handleChange = this.handleChange.bind(this);
    this.validate = this.validate.bind(this);
  }

  inputClass() {
    if (this.props.value == '') {
      return 'initialized';
    }
    if (this.props.valid) {
      return 'valid';
    }
    return 'error';
  }

  validate(value) {
    let valid = false;
    let errors = []; // this.props.errorMessage

    // iterate through the validations and collect any errors
    this.props.validations.map(function (validation) {
      if (validation.pattern) {
        valid = value.search(validation.pattern) != -1;
      }

      if (!valid) {
        errors = validation.key;
        this.setState({
          valid: false,
          inputClass: 'error',
          errors,
        });
      } else {
        this.setState({
          inputClass: 'valid',
          valid: true,
          errors: '',
        });
      }
    }, this);
    return valid;
  }

  componentWillUnmount() {
    AccountStore.off(null, null, this);
  }

  componentDidMount() {
    this.setState({
      inputClass: this.props.inputClass,
      valid: this.props.valid,
      value: this.state.value,
    });

    AccountStore.on(
      'password:update:success',
      function (data) {
        this.setState(this.initialState);
      },
      this,
    );

    AccountStore.on('password:update:failed', (data) => {}, this);
  }

  handleChange(e) {
    // if the component or parent component is not active, please do nothing.
    // firefox erroneously prepopulates the current_password field otherwise
    if (this.props.activeState != 'active') return false;
    const { value } = e.target;
    const valid = this.validate(value);
    // callback to parent component handlechange
    this.props.handleChange(e.target.value, valid);
    this.setState({
      value: e.target.value,
      len: e.target.value.length,
    });
  }

  render() {
    const className = `field ${this.props.inputClass}`;
    return (
      <div className={className}>
        <label htmlFor={this.props.name}>{this.props.label}</label>
        <input
          autoComplete="no"
          name={this.props.name}
          value={this.state.value}
          onChange={this.handleChange}
          placeholder={this.props.placeholder}
          type="password"
        />
        <div className="message">{this.props.errorMessages}</div>
      </div>
    );
  }
}
